import React from 'react';
const images = {
  modules: {
    src: 'https://cdn.magicpatterns.com/uploads/7EmD2AC3VDmoCZPKaiQwS4/Imagen_de_ChatGPT_27_sept_2026,_08_34_54_p.m..png',
    alt: 'Megapack Maestro de Sesiones: los 6 módulos en espiral junto al volumen principal del sistema'
  },
  fullPack: {
    src: 'https://cdn.magicpatterns.com/uploads/njrXsC7zcCGsvREjrwUArV/Imagen_de_ChatGPT_27_sept_2026,_08_41_25_p.m..png',
    alt: 'Megapack Maestro de Sesiones completo: el volumen principal, los 6 módulos y los 5 bonos profesionales'
  }
};
type BookStackProps = {
  className?: string;
  variant?: keyof typeof images;
};
export function BookStack({
  className = '',
  variant = 'modules'
}: BookStackProps) {
  const img = images[variant];
  return <div className={`mx-auto w-full max-w-[860px] ${className}`} data-id="element-46" data-mp="1pmb1ql0q5dkq">
      <img src={img.src} alt={img.alt} className="h-auto w-full mix-blend-multiply" width={1448} height={1086} data-id="element-47" data-mp="3f07en0clkdn7" />
    </div>;
}